import { render, staticRenderFns } from "./box1.vue?vue&type=template&id=7d0498d2&scoped=true"
import script from "./box1.vue?vue&type=script&lang=js"
export * from "./box1.vue?vue&type=script&lang=js"
import style0 from "./box1.vue?vue&type=style&index=0&id=7d0498d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0498d2",
  null
  
)

export default component.exports